import React from 'react';

import { Accordion } from '@zillow/constellation-10';

import { VIEW_TYPE } from './constants';

type WizardTipProps = {
  header?: string | null;
  viewType: string;
  children: React.ReactNode;
};
const WizardTip = ({ header = null, viewType = VIEW_TYPE.ACCORDION, children }: WizardTipProps) => {
  const renderAccordion = () => {
    return (
      <Accordion.Root>
        <Accordion.Item value="wizard-tip">
          <Accordion.Header>{header}</Accordion.Header>
          <Accordion.Panel>{children}</Accordion.Panel>
        </Accordion.Item>
      </Accordion.Root>
    );
  };

  const renderCard = () => {
    return <>{children}</>;
  };

  return <div data-testid="WizardTip">{viewType === VIEW_TYPE.ACCORDION ? renderAccordion() : renderCard()}</div>;
};

export default WizardTip;
